import * as React from 'react';

import GenericImage from '@lendi-jam/generic-image';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';

import { GenericImageContent } from '#contentTypes/GenericImage';

interface PrismicGenericImageProps {
  component: GenericImageContent;
}

const PrismicGenericImage: React.FC<PrismicGenericImageProps> = ({ component: { primary } }) => (
  <GenericImage src={primary.image.url} alt={primary.image.alt} size={primary.size} link={embedMarketingTrackingIntoURL(primary.link_url.url)} />
);

export default PrismicGenericImage;
